export enum CrossTabMessageType {
  CartUpdated = 'cart_updated',
  SessionChanged = 'session_changed',
  /** The order on `cartId` completed; every other tab showing that cart leaves for its landing. */
  OrderCompleted = 'order_completed'
}

interface CrossTabMessage {
  type: CrossTabMessageType
  cartId?: string
}

// One channel per tab: a second `BroadcastChannel` of the same name would deliver this tab's own
// posts back to it.
let channel: BroadcastChannel | null = null

function crossTabChannel(): BroadcastChannel {
  channel ??= new BroadcastChannel('cady_storefront')
  return channel
}

/** Posts `type` to every other open storefront tab, with the cart it concerns when it names one. */
export function postCrossTabMessage(type: CrossTabMessageType, cartId?: string): void {
  const message: CrossTabMessage = cartId ? { type, cartId } : { type }
  crossTabChannel().postMessage(message)
}

const knownTypes = new Set<unknown>(Object.values(CrossTabMessageType))

/**
 * Calls `handler` with each message another tab posts, skipping any type this release does not know.
 * Returns the unsubscribe.
 */
export function onCrossTabMessage(
  handler: (type: CrossTabMessageType, cartId: string | null) => void
): () => void {
  const listener = (event: MessageEvent<Partial<CrossTabMessage> | null>) => {
    const type = event.data?.type
    const cartId = event.data?.cartId
    if (knownTypes.has(type)) {
      handler(type as CrossTabMessageType, typeof cartId === 'string' ? cartId : null)
    }
  }
  crossTabChannel().addEventListener('message', listener)
  return () => crossTabChannel().removeEventListener('message', listener)
}
